import { createReducer } from 'typesafe-actions';
import {
  getContractPackageDetailsAsync,
  resetContractPackageDetails,
} from './actions';
import {
  ContractPackageVersion,
  ContractTypes,
  DeployContractPackageResult,
  FTBalanceTokenResult,
  FTTokenOwnerResult,
  isContractTypeCep18,
  NFTTokenOwnerResult,
  NFTTokenResult,
} from '@block-explorer/entities';
import { PaginatedResponse } from '../../services';

export type State = {
  contractPackageInfo: DeployContractPackageResult | null;
  holders: PaginatedResponse<FTTokenOwnerResult> | null;
  nftTokens: PaginatedResponse<NFTTokenResult> | null;
  ftTokens: PaginatedResponse<FTBalanceTokenResult> | null;
  owners: NFTTokenOwnerResult[] | null;
  versions: ContractPackageVersion[] | null;
  isCep18: boolean;
  isNFT: boolean;
  loading: boolean;
  error?: string | null;
};

const initialState: State = {
  contractPackageInfo: null,
  holders: null,
  nftTokens: null,
  ftTokens: null,
  owners: null,
  isCep18: false,
  isNFT: false,
  versions: null,
  loading: true,
};

export default createReducer(initialState)
  .handleAction(
    getContractPackageDetailsAsync.request,
    (state, action): State => {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
  )
  .handleAction(
    getContractPackageDetailsAsync.success,
    (state, action): State => {
      const [
        contractPackageInfo,
        holders,
        nftTokens,
        ftTokens,
        owners,
        versions,
      ] = action.payload;

      const isCep18 = isContractTypeCep18(contractPackageInfo?.data);
      const contractVersionId =
        contractPackageInfo?.data?.latest_version_contract_type_id;
      const isNFT =
        contractVersionId != null &&
        [
          ContractTypes.CEP47Nft,
          ContractTypes.CustomCEP47Nft,
          ContractTypes.CEP78Nft,
          ContractTypes.CustomCEP78Nft,
          ContractTypes.CEP95Nft,
        ].includes(contractVersionId);

      return {
        ...state,
        contractPackageInfo: contractPackageInfo?.data ?? null,
        holders: holders,
        nftTokens: nftTokens,
        ftTokens: ftTokens,
        owners: owners.data,
        versions: versions?.data ?? null,
        isCep18,
        isNFT,
        loading: false,
        error: null,
      };
    }
  )
  .handleAction(
    getContractPackageDetailsAsync.failure,
    (state, action): State => {
      return {
        ...state,
        loading: false,
        error: action.payload.error?.message || null,
      };
    }
  )
  .handleAction(
    resetContractPackageDetails,
    (state): State => ({
      ...state,
      ...initialState,
    })
  );
